export default '/build/d920fddd.svg'